import {Props} from '../model';
import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../shared/hooks/styles';
import {datePipe} from '../../../../shared/pipes/date';
import {dateFormats} from '../../../../shared/constants/date';
import {PollResponsePayload} from '../../../../shared/models/api';
import {PollsButton} from '../button';
import {Text} from '../../../../shared/components/text';

export default (props: Props) => {
  const styles = useStyles(({theme, addShadow}) => ({
    container: {},
    item: {
      marginBottom: 20,
      padding: 20,
      borderRadius: 14,
      backgroundColor: theme.color.primaryNonGreyBackground,
      ...addShadow({
        opacity: 0.1,
        height: 2,
        radius: 18,
      }),
    },
    name: {
      ...theme.fonts.body,
      textAlign: 'center',
      marginBottom: 6,
    },
    datesText: {
      textAlign: 'center',
      ...theme.fonts.label,
      color: theme.color.labelText,
      marginBottom: 15,
    },
    buttonAction: {
      width: 140,
    },
    action: {
      alignItems: 'center',
    },
  }));

  const Card = ({poll}: {poll: PollResponsePayload}) => {
    return (
      <View style={styles.item}>
        <Text testID={`poll-${poll.id}-topic-id`} style={styles.name}>
          {poll.topic}
        </Text>
        <Text testID={`poll-${poll.id}-date-id`} style={styles.datesText}>
          {datePipe(poll.startDate, dateFormats.shortDate)} - {datePipe(poll.endDate, dateFormats.shortDate)}
        </Text>
        <View style={styles.action}>
          <PollsButton poll={poll} />
        </View>
      </View>
    );
  };

  return (
    <View style={styles.container}>
      {props.polls?.map((item) => (
        <Card poll={item} key={item.id} />
      ))}
    </View>
  );
};
